import React from 'react';

import { MediaCMS } from 'utils/sharedStrapiQueries/sharedTypes';

import * as S from './JoinUsImageBlock.styles';

export interface JoinUsImageBlockProps {
  image: MediaCMS;
  imageCaption: string;
}

const defaultProps: Partial<JoinUsImageBlockProps> = {};

const JoinUsImageBlock: React.FunctionComponent<JoinUsImageBlockProps> = ({
  image,
  imageCaption,
}) => {
  return <S.Image src={image.url} alt={imageCaption} />;
};

JoinUsImageBlock.defaultProps = defaultProps;

export default JoinUsImageBlock;
